import SocialData from '@type/sorr2025/SocialData';
import createBarGradient from '@functions/sorr2025/createBarGradient/createBarGradient';
import createImage from '@functions/sorr2025/createImage/createImage';
import Chart from 'chart.js/auto';
import socialChartConfig from '@functions/sorr2025/chartConfigs/socialChartConfig';

declare global {
    interface Window {
        socialValue: {
            label: string;
            value: number;
        }[];
    }
}

const initializeSocialChart = () => {
    const socialCanvas = document.getElementById('chart-social') as HTMLCanvasElement;

    const socialContext = socialCanvas.getContext('2d');

    const socialIcons = [
        {
            label: 'Facebook',
            background: createBarGradient(socialContext, 'rgb(3,54,70)', 'rgb(6,85,110)'),
            logo: createImage('logo-facebook.svg'),
        },
        {
            label: 'Instagram',
            background: createBarGradient(socialContext, 'rgb(6,85,110)', 'rgb(0,163,173)'),
            logo: createImage('logo-instagram.svg'),
        },
        {
            label: 'TikTok',
            background: createBarGradient(socialContext, 'rgb(163,118,18)', 'rgb(255,184,28)'),
            logo: createImage('logo-tiktok.svg'),
        },
        {
            label: 'Snapchat',
            background: createBarGradient(socialContext, 'rgb(197,85,67)', 'rgb(241,102,81)'),
            logo: createImage('logo-snapchat.svg'),
        },
        {
            label: 'Twitter(X)',
            background: createBarGradient(socialContext, 'rgb(38,75,64)', 'rgb(76,151,129)'),
            logo: createImage('logo-twitter.svg'),
        },
    ];

    const socialData: SocialData[] = socialIcons.map((i) => {
        const matched = window.socialValue.find((j) => j.label === i.label);
        return {
            ...i,
            value: matched ? matched.value : null,
        };
    });

    const chartLabels = socialData.map((entry) => entry.label);
    const chartData = socialData.map((entry) => entry.value);
    const chartColors = socialData.map((entry) => entry.background);

    let socialChart = new Chart(
        socialContext,
        socialChartConfig({ data: socialData, chartLabels, chartData, chartColors })
    );

    let isLargeScreen = window.innerWidth >= 1440;

    const reinitializeChart = () => {
        socialChart.destroy();
        socialChart = new Chart(
            socialContext,
            socialChartConfig({ data: socialData, chartLabels, chartData, chartColors })
        );
    };

    window.addEventListener('resize', () => {
        const currentScreenSize = window.innerWidth >= 1440;
        if (currentScreenSize !== isLargeScreen) {
            isLargeScreen = currentScreenSize;
            reinitializeChart();
        }
    });
};

export default initializeSocialChart;
